var exports = {
  "h": "alignWithCards__KY50lB",
};

module.exports = exports;
